// extracted by mini-css-extract-plugin
module.exports = {"player":"player-c913eb82","playerWrapper":"playerWrapper-9d633bd5"};